import { FlagOutlined, MessageOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Col, Modal, Row, Space, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MessagesNoReply from "../MessagesNoReply/MessagesNoReply";
import Moderation from "../Moderation/Moderation";
import SavedMessages from "../SavedMessages/SavedMessages";
import SendDM from "../SendDM/SendDM";

const { TabPane } = Tabs;

const Messages = (props) => {
  const platform = localStorage.getItem("platform");
  const [isDmVisible, setIsDmVisible] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const showDmModal = () => {
    setIsDmVisible(true);
  };

  const cancelDm = () => {
    setIsDmVisible(false);
  };

  useEffect(() => {
    // console.log(props.location.state)
    if (location.state && location.state.direct_message) {
      // console.log("sup", props.location.state)
      setIsDmVisible(true);
    }
  }, [location.state]);

  useEffect(() => {
    document.title = "Messages | Dots";
  }, []);

  const modalStyle = { top: 40, right: 10 };

  return (
    <div>
      <Row>
        <Col span={8} />
        <Col span={8} offset={8} style={{ textAlign: "end" }}>
          <Space>
            <Modal
              width={700}
              title="Schedule DM"
              style={modalStyle}
              visible={isDmVisible}
              onCancel={cancelDm}
              footer={[
                <Button key="submit" onClick={cancelDm}>
                  Cancel
                </Button>,
              ]}
            >
              <SendDM closeModal={cancelDm} sendNow />
            </Modal>
          </Space>
        </Col>
      </Row>

      <Tabs defaultActiveKey={path}>
        <TabPane
          tab={
            <span>
              <span className="-mt-1">
                <MessageOutlined />
              </span>
              <span className="-ml-1">Messages w/o replies</span>
            </span>
          }
          key="/messages"
          // style={{ padding: 20 }}
        >
          <MessagesNoReply />
        </TabPane>

        <TabPane
          tab={
            <span>
              <span className="-mt-1">
                <SaveOutlined />
              </span>
              <span className="-ml-1">Saved</span>
            </span>
          }
          key="/saved"
          style={{ padding: 20 }}
        >
          <SavedMessages />
        </TabPane>

        <TabPane
          tab={
            <span>
              <span className="-mt-1">
                <FlagOutlined />
              </span>
              <span className="-ml-1">Moderation queue</span>
            </span>
          }
          key="/moderation"
          style={{ padding: 20 }}
        >
          <Moderation />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Messages;
